import * as React from "react";

import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";
import "./branded-header.scss";

export const BrandedHeader = ({themeScheme}) => {
    const [showUpgradeHeader, setShowUpgradeHeader] = React.useState(true)

    let headerBackgroundColor = themeScheme?.xpresso?.menuBackgroundColor
    if(themeScheme?.xpresso?.headerBanner) {
        headerBackgroundColor = themeScheme?.xpresso?.headerColor
    }
    
    return (
        <>
            {
                showUpgradeHeader &&
                <header 
                    className="header-br0 upgrade"
                >
                    <p><strong>Welcome!</strong>{messageWelcome}</p>
                    <p>{messageUpgrade(themeScheme)}</p>
                   
                    <FontAwesomeIcon
                        icon={require('@fortawesome/free-solid-svg-icons')['faClose']}
                        className='icon-close'
                        onClick={() => setShowUpgradeHeader(false)}
                    />
                </header>
            }
            <header 
                className="header-br0"
                style={{
                    backgroundColor: headerBackgroundColor,
                    color: themeScheme?.xpresso?.menuTextColor
                }}
            >
                {
                    themeScheme?.xpresso?.headerLogo &&
                        <div className="logo">
                            <img
                                src={themeScheme?.xpresso?.headerLogo} 
                                alt="header-logo" 
                            />
                        </div>
                }
                {
                    themeScheme?.xpresso?.headerBanner &&
                        <div 
                            className="banner"
                            style={{
                                backgroundColor: themeScheme?.xpresso?.headerColor
                            }}
                        >
                            <img
                                src={themeScheme?.xpresso?.headerBanner} 
                                alt="header-banner" 
                            />
                        </div>
                }
            </header>
        </>
    )
}

const messageWelcome = ` We've upgraded our interface to offer a better user experience.`

const ID_K_HOVNANIAN_HOMES = '8daf885c'
const ID_LEVITON = 'fb7339ff'

const messageUpgradeDefault = `If you are logging in for the first time, please log in with your email address and the 
    password that was communicated to you by Xpressdocs Marketing.`

const messageUpgradeKHovnanian = `Please login with your existing username and password.`

const messageUpgradeLeviton = `Please login with your email address and Leviton01.`

const messageUpgrade = (themeSceme) => {
    switch(themeSceme?.schemeLevelId) {
        case ID_K_HOVNANIAN_HOMES:
            return messageUpgradeKHovnanian
        case ID_LEVITON:
            return messageUpgradeLeviton
        default:
            return messageUpgradeDefault
    }
}